<template>
    <div>
        <h1>의약품 배송 서비스 이용약관</h1>
        <h3>제1조(목적)</h3>
        이 약관은 솔닥 주식회사(이하 "회사")가 서비스 이용약관 제4조 제1항 제3호에 따라 제공하는 의약품 배송 서비스의 이용조건과 절차, 회사와 이용자의 권리·의무에 관한 사항을 정함을 목적으로 합니다.<br>
        <h3>제2조(정의)</h3>
        ① "제휴약국"이란 회사와 협약을 체결하고 의약품 배송 서비스에 참여하는 약국을 말합니다.<br>
        ② "운송인"이란 의약품의 운송을 수행하는 운송사업자를 말합니다.<br>
        ③ 이 약관에서 정하지 아니한 용어의 뜻은 서비스 이용약관에서 정한 바에 따릅니다.<br>
        <h3>제3조(다른 약관과의 관계)</h3>
        ① 의약품 배송 서비스에 관하여 이 약관에서 정한 사항은 서비스 이용약관에 우선하여 적용됩니다.<br>
        ② 이 약관에서 정하지 아니한 사항은 서비스 이용약관 및 관계 법령에 따릅니다.<br>
        <h3>제4조(의약품 배송 서비스의 이용 자격)</h3>
        ① 의약품 배송 서비스는 관계 법령 및 보건복지부 지침에 따라 약국 외의 장소에서 의약품을 수령할 수 있는 이용자에 한하여 제공됩니다.<br>
        ② 제1항의 자격이 확인되지 아니한 경우 회사는 서비스 제공을 거부할 수 있습니다.<br>
        <h3>제5조(의약품 배송 서비스의 신청과 승낙)</h3>
        ① 이용자는 의약품 배송 서비스 신청 시 이 약관 및 회사가 별도로 고지하는 배송 관련 중요 고지사항을 확인하고 이에 동의하여야 하며, 조제를 의뢰할 제휴약국을 직접 선택합니다.<br>
        ② 제1항의 배송 관련 중요 고지사항은 의약품 배송 서비스의 구체적인 이용조건으로서 이 약관과 함께 적용됩니다.<br>
        ③ 회사는 다음 각 호의 어느 하나에 해당하는 경우 신청을 승낙하지 아니하거나 승낙을 취소할 수 있습니다.<br>
        1. 제4조의 이용 자격을 갖추지 못한 경우<br>
        2. 이용자가 요청한 배송지가 배송이 가능한 지역이 아닌 경우<br>
        3. 약사가 조제 또는 배송이 적절하지 아니하다고 판단한 경우<br>
        4. 이용자가 제공한 정보가 사실과 다르거나 필요한 정보를 제공하지 아니한 경우<br>
        5. 그 밖에 관계 법령, 보건복지부 지침 또는 의약품의 안전한 배송을 위하여 서비스 제공이 곤란하다고 판단되는 경우<br>
        <h3>제6조(포장과 발송)</h3>
        조제된 의약품은 제휴약국이 포장하여 운송인에게 인계하는 방법으로 발송됩니다.<br>
        <h3>제7조(배송과 인도)</h3>
        ① 의약품의 수령 방식은 관계 법령 및 보건복지부 지침이 정하는 범위에서 이용자와 제휴약국이 협의하여 정하며, 이용자 본인이 직접 수령하는 것을 원칙으로 합니다.<br>
        ② 이용자가 대리 수령이나 특정 장소에서의 수령을 요청한 경우에는 해당 대리인에게 의약품이 전달되거나 이용자가 요청한 특정 장소에 의약품 보관이 완료된 시점에 인도가 완료된 것으로 봅니다. 다만, 이용자 본인 직접 수령을 선택하였더라도 이용자의 부재, 공동현관 출입 제한, 연락 불응답 등으로 이용자 본인에게 직접 인도하기 어려운 경우에는 경비실, 무인택배함 등 대체 장소에 보관할 수 있으며 그 경우 보관이 완료된 시점에 인도가 완료된 것으로 봅니다.<br>
        ③ 회사 또는 운송인의 고의 또는 중대한 과실이 없는 한, 인도가 완료된 이후에 발생한 분실, 도난 또는 변질에 대하여 회사는 책임을 지지 아니합니다.<br>
        <h3>제8조(의약품 배송 이용자의 의무)</h3>
        ① 이용자는 수령한 의약품을 해당 의약품의 보관 방법에 따라 지체 없이 보관하여야 합니다.<br>
        ② 이용자는 수령한 의약품의 상태에 이상이 있는 경우 이를 사용하지 아니하고 회사에 알려야 합니다.<br>
        ③ 이용자가 의약품을 수령한 후 제1항 또는 제2항을 위반하여 의약품의 변질·훼손 또는 그 밖의 손해가 발생한 경우, 회사는 고의 또는 중대한 과실이 없는 한 그 손해에 대하여 책임을 부담하지 않습니다.<br>
        <h3>제9조(조제 착수 후의 취소 제한)</h3>
        제휴약국에 처방전이 전송되어 처방전에 따른 조제가 시작된 이후에는 이용자의 단순한 의사 변경에 의한 취소 및 환불이 제한됩니다.<br>
        <h3>제10조(반송과 폐기)</h3>
        ① 이용자의 수령 거부, 장기 부재 등의 사유로 의약품이 제휴약국에 반송된 경우, 반송된 의약품은 재배송 또는 재사용하지 아니하고 제휴약국이 관계 법령 및 보건복지부 지침 등에 따라 폐기합니다.<br>
        ② 제1항에 따른 반송 사유가 이용자의 귀책에 기인하는 경우, 해당 의약품 대금 환불이 제한되거나 실제 발생한 반송비용을 이용자가 부담할 수 있습니다. 다만 회사 또는 제휴약국의 귀책사유로 반송된 경우에는 그러하지 아니합니다.<br>
        <h3>제11조(배상 지원)</h3>
        운송 중 회사 또는 운송인의 귀책사유로 의약품이 분실, 훼손 또는 변질된 경우, 회사는 이용자가 재처방을 받을 수 있도록 지원하며, 이를 위하여 필요한 재처방 및 의약품 대금 비용을 배상합니다.<br>
        <h3>제12조(약관의 효력과 종료)</h3>
        ① 이 약관은 2026년 9월 14일부터 시행합니다.<br>
        ② 이 약관은 서비스 이용약관에 이 약관과 같은 내용의 의약품 배송 서비스 관련 조항이 반영되어 시행되는 날(이하 "종료일")부터 효력을 잃으며, 종료일 이후의 의약품 배송 서비스 신청에는 서비스 이용약관이 적용됩니다.<br>
        ③ 종료일 전에 신청된 의약품 배송 서비스에 관하여는 그 이행, 정산 및 분쟁의 처리가 끝날 때까지 이 약관이 계속 적용되며, 이 약관에 따라 이미 발생한 이용자의 권리와 회사의 의무는 종료 후에도 존속합니다.<br>
        ④ 회사는 종료일을 서비스 이용약관 개정 공지를 통하여 안내하고, 종료된 이 약관을 보존하여 이용자의 요청이 있는 경우 제공합니다.<br>
        <h3>부칙</h3>
        이 약관은 2026년 9월 14일부터 시행합니다.
    </div>
</template>

<script>
export default {
    name: 'medicineDeliveryTerms'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/MedicineDeliveryTerms.vue